import { getDataIdGenerator } from '../../../shared/utils/dataId';
import { EmptyWidget } from '../../../shared/components/EmptyWidget/EmptyWidget';
import { useDocLink } from '../../hooks/useDocLink';

export interface DocsLoadingErrorProps {
  dataId: string;
  title: string;
  docLink: string;
}

export function DocsLoadingError({ title, docLink, dataId }: DocsLoadingErrorProps) {
  const { getLinkURL } = useDocLink();

  return (
    <EmptyWidget
      title={title}
      dataId={getDataIdGenerator(dataId, 'docs-loading-error')('')}
      className='h-100 w-auto'
      secondaryCTAProps={{
        tag: 'a',
        children: 'Go to Documentation',
        target: '_blank',
        icon: 'new-window',
        href: getLinkURL(docLink, 'source_settings_side-by-side_guide')
      }}
    />
  );
}
